export default import.meta.ROLLDOWN_FILE_URL_b0xqm$5zEcMd2Q0C8kVUaA